import { z } from "zod";
// Response shapes for the geo reference-data endpoints (GET /geo/countries and
// GET /geo/countries/:code/subdivisions). Intentionally schema-only — this file
// imports no geo datasets, so the web can use these types without pulling the
// ISO libraries (those stay behind the @guestbook/shared/geo subpath) into the
// client bundle.
/** A selectable country or subdivision: a code plus its English name. */
export const geoItemSchema = z.object({
    code: z.string(),
    name: z.string(),
});
export const geoCountriesResponseSchema = z.object({
    items: z.array(geoItemSchema),
});
export const geoSubdivisionsResponseSchema = z.object({
    items: z.array(geoItemSchema),
});
//# sourceMappingURL=geo.js.map